const path = {
    // dev: 'http://192.168.10.200:9999',
    dev: 'http://yyt.hbswjt.net/',
    save: ''
}
export { path }